import React from 'react'

import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Theme, useTheme } from '@mui/material/styles'

import ConsultationsSearchForm from './containers/ConsultationsSearchForm'
import ConsultationsTable from './containers/ConsultationsTable'
import PageContainer from '@/components/ui/containers/PageContainer'
import { Drawer, Paper, Toolbar } from '@mui/material'
import { useIntro } from '@/hooks/useIntro'
import { ViewConsultationsIntro } from '@/utils/onboarding/intro'
import { CreateConsultationButton } from './components/CreateConsultationButton'

const sidebarWidth = 300
type ConsultationsPageProps = {}

const ConsultationsPage = (props: ConsultationsPageProps) => {
  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))

  useIntro(ViewConsultationsIntro)
  return (
    <PageContainer>
      <Grid container>

        {isLargeScreen && (
          <Grid item>

            <Drawer
              variant="permanent"
              sx={{
                width: sidebarWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: {
                  width: sidebarWidth,
                  boxSizing: 'border-box',
                  pb: '20px',
                  [theme.breakpoints.up('md')]: {
                    position: 'absolute',
                  },
                },
              }}
            >
              <Toolbar />
              <ConsultationsSearchForm />
            </Drawer>
          </Grid>
        )}
        <Grid item xs={isLargeScreen ? true : 12}>
          <Grid container spacing={2}>
            <Grid container item xs={12} spacing={2}>
              <Grid item xs={12}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <CreateConsultationButton />
                </Stack>
              </Grid>
              {!isLargeScreen && (
                <Grid item xs={12} lg={8} xl={9}>
                  <Paper sx={{ mb: '20px', pt: '1px', pb: '15px' }} id="consultation-search-form">
                    <ConsultationsSearchForm />
                  </Paper>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12}>
              <ConsultationsTable />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </PageContainer>
  )
}

export default ConsultationsPage